import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '@/components/layout/AdminSidebar';
import Topbar from '@/components/layout/Topbar';

/**
 * AdminLayout - Super admin dashboard shell
 * 
 * RESPONSIBILITIES:
 * - Admin-specific sidebar navigation
 * - Topbar (minimal, no business selector)
 * - Page container framing
 * - Visually distinct from customer layout
 * 
 * DOES NOT:
 * - Fetch data
 * - Contain business logic
 * - Make API calls
 * - Handle permissions (pages handle that)
 */
export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [window.location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Admin Sidebar (purple accent) */}
      <AdminSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content area */}
      <div className="lg:pl-64">
        {/* Topbar (admin variant) */}
        <Topbar 
          variant="admin"
          onMenuClick={() => setSidebarOpen(true)} 
        />
        
        {/* Page content */}
        <main className="pt-16">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
